/**
 * sidebarCollapsedPref.ts — the remembered rail state (Sidebar v2 slice S2,
 * RULED 2026-10-11 (2)): ONE device-level key through draftStorage's guard —
 * no tenant, no subject — so the shell can read it SYNCHRONOUSLY at its first
 * render, before /v1/me resolves, and a collapsed user never sees the
 * expanded sidebar snap shut on load. Default EXPANDED: anything but a stored
 * `true` (absent, `false`, corrupt, storage that throws) reads expanded.
 */
import { readDraft, writeDraft } from './draftStorage'

export const SIDEBAR_COLLAPSED_KEY = 'gss.pref.sidebarCollapsed'

export function readSidebarCollapsed(): boolean {
  return readDraft<unknown>(SIDEBAR_COLLAPSED_KEY) === true
}

export function writeSidebarCollapsed(collapsed: boolean): void {
  writeDraft(SIDEBAR_COLLAPSED_KEY, collapsed)
}
